<template>
  <!-- Sidebar -->
  <nav class="sidebar" :class="{ active: activeSidebar }">
    <div class="sidebar-header text-center">
      <img :src="logoUrl" alt="Logo da Empresa" class="img-fluid">
    </div>

    <ul class="list-unstyled">
      <li :class="{ active: isMenuActive('/usuario') }" v-if="isAdminJaleko">
        <router-link :to="{path: '/usuario'}"><i class="fas fa-user-circle"></i> Usuários</router-link>
      </li>
      <li :class="{ active: isMenuActive('/cupom') }" v-if="isAdminJaleko">
        <router-link :to="{path: '/cupom'}"><i class="fas fa-ticket-alt"></i> Cupom</router-link>
      </li>
      <li :class="{ active: isMenuActive('/cortesia') }" v-if="isAdminJaleko">
        <router-link :to="{path: '/cortesia'}"><i class="fas fa-gift"></i>  Cortesia</router-link>
      </li>
      <li :class="{ active: isMenuActive('/assinaturas') }" v-if="isAdminJaleko">
        <router-link :to="{path: '/assinaturas'}"><i class="fas fa-credit-card"></i>  Assinaturas</router-link>
      </li>
      <li v-if="false">
        <a href="#"><i class="far fa-file-alt"></i> Relatórios</a>
      </li>
      <li v-if="false">
        <a href="#"><i class="far fa-life-ring"></i> Suporte</a>
      </li>
    </ul>
  </nav>
</template>

<script>

import { TipoPerfilUtil } from '@/core/types/tipo-perfil'
import LoginUtils from '@/core/util/login-utils'
import EmpresaUtils from '@/core/util/empresa-utils'

export default {
  name: 'MenuLateralPrincipal',
  props: {
    activeSidebar: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    isMaster: function () {
      return TipoPerfilUtil.isMaster(LoginUtils.getUsuario().perfil_id)
    },

    isAdminJaleko: function () {
      return TipoPerfilUtil.isAdminJaleko(LoginUtils.getUsuario().perfil_id)
    },

    isAdmin: function () {
      return TipoPerfilUtil.isAdmin(LoginUtils.getUsuario().perfil_id)
    },

    isAdminRestrito: function () {
      return TipoPerfilUtil.isAdminRestrito(LoginUtils.getUsuario().perfil_id)
    },

    isAnalista: function () {
      return TipoPerfilUtil.isAnalista(LoginUtils.getUsuario().perfil_id)
    },

    isProfessor: function () {
      return TipoPerfilUtil.isProfessor(LoginUtils.getUsuario().perfil_id)
    },

    isEditor: function () {
      return TipoPerfilUtil.isEditor(LoginUtils.getUsuario().perfil_id)
    },

    isAluno: function () {
      return TipoPerfilUtil.isAluno(LoginUtils.getUsuario().perfil_id)
    },

    logoUrl: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}empresas/logos/${EmpresaUtils.getEmpresa().id}/light.png`
    }
  },

  methods: {
    isMenuActive: function (path) {
      return this.$route.path === path || this.$route.path.includes(`${path}/`)
    }
  }
}
</script>

<style scoped>

</style>
